import { responseType } from "../constants";
import { EvalSearchResult } from "../types/eval/EvalSearchResult";
import { fetchSafe } from "./fetch.safe";

export const evalService = {
    searchEval,
    exportData
}

function searchEval(searchParams: Record<string, any>): Promise<EvalSearchResult> {
    return fetchSafe('/api/eval', {
        method: 'POST', body: JSON.stringify({
            ...searchParams, 
        })
    });
}

function exportData(searchParams: Record<string, any>): Promise<{ blob: Blob, name: string }> {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(searchParams),
        responseType: responseType.file
    };

    return fetchSafe('/api/eval/export', requestOptions)
}